module.exports = __webpack_public_path__ + "img/microplastics-process-10-mobile.754da259.png";